module.exports = __webpack_public_path__ + "static/media/laptop-and-news.029fc7e1.png";